interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  label?: string
}

export function Spinner({ size = 'md', label = 'Loading…' }: SpinnerProps) {
  const px = size === 'sm' ? 16 : size === 'lg' ? 40 : 24
  return (
    <>
      <div className="spinner-wrap" role="status" aria-label={label}>
        <div className="spinner" style={{ width: px, height: px }} />
        {size !== 'sm' && <span className="spinner-label">{label}</span>}
      </div>

      <style>{`
        .spinner-wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 12px;
        }
        .spinner {
          border: 2px solid var(--border);
          border-top-color: var(--accent);
          border-radius: 50%;
          animation: spin 0.7s linear infinite;
        }
        .spinner-label {
          font-size: 0.8rem;
          color: var(--text-muted);
        }
      `}</style>
    </>
  )
}
